"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoImage = void 0;
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NoImage = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_no_image },
        react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: "/images/no-image.svg" })));
};
exports.NoImage = NoImage;
